import type { PublicUser } from '@cult/schemas';
import { redirect } from '@tanstack/react-router';
import { useCurrentUser } from '../../state/use-current-user';
import type { AdminGuardResult } from './admin-guard';

/** Builds a route `beforeLoad` that redirects when the guard rejects the already-loaded current user. */
export const requireAdminAccess = (evaluate: (me: PublicUser | null) => AdminGuardResult) => () => {
  const result = evaluate(useCurrentUser.getState().user);
  if ('redirectTo' in result) throw redirect({ to: result.redirectTo });
};
